export default __webpack_public_path__ + "static/media/distancing.d9e7cd09.png";